import {
  globalConstants,
  adminActionConstants,
  instructorConstants,
  freelanceInstructorConstants,
} from "../../constants";

const initialState = {
  instructorsData: { page: {}, pageData: [] },
  instructorData: null,
  isViewModalOpen: false,
  isApprovalModalOpen: false,
  instructorRequestedApprovalsList: [],
  instructorRequestedApprovalsPagination: null,
  spotInctructorData: { page: {}, pageData: [] },
  instructorSports: {},
  freelanceInstructorSportsDetail: {},
  instructorCenterDetail: {},
  isFreelanceModalOpen: false,
  allCenterInstructors: [],
};

const {
  INSTRUCTORS_DATA,
  INSTRUCTOR_DATA,
  VIEW_MODAL,
  APPROVAL_MODAL,
  SPOT_INSTRUCTORS_DATA,
  INSTRUCTOR_SPORTS,
  INSTRUCTOR_CENTER_DETAIL,
  GET_ALL_CENTER_INSTRUCTORS,
} = instructorConstants;
const {
  GET_APPROVAL_REQUESTED_INSTRUCTORS,
  GET_APPROVAL_REQUESTED_INSTRUCTOR_DATA_BY_ID,
} = adminActionConstants;

const InstructorReducer = (state = initialState, action) => {
  switch (action.type) {
    case INSTRUCTORS_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        instructorsData: action.data,
      };
    case INSTRUCTOR_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        instructorData: action.data,
      };
    case VIEW_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        isViewModalOpen: action.data,
      };
    case APPROVAL_MODAL:
      return {
        ...state,
        isApprovalModalOpen: action.data,
      };
    case GET_APPROVAL_REQUESTED_INSTRUCTORS + globalConstants.SUCCESS:
      return {
        ...state,
        instructorRequestedApprovalsList: action.data.pageData,
        instructorRequestedApprovalsPagination: action.data?.page,
      };
    case GET_APPROVAL_REQUESTED_INSTRUCTOR_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        instructorData: action.data,
      };
    case SPOT_INSTRUCTORS_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        spotInctructorData: action.data,
      };
    case INSTRUCTOR_SPORTS + globalConstants.SUCCESS:
      return {
        ...state,
        instructorSports: action.data,
      };
    case freelanceInstructorConstants.FREELANCE_INSTRUCTOR_SPORTS_DETAIL +
      globalConstants.SUCCESS:
      return {
        ...state,
        freelanceInstructorSportsDetail: action.data,
      };
    case INSTRUCTOR_CENTER_DETAIL + globalConstants.SUCCESS:
      return {
        ...state,
        instructorCenterDetail: action.data,
      };
    case freelanceInstructorConstants.FREELANCE_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        isFreelanceModalOpen: action.data,
      };
    case GET_ALL_CENTER_INSTRUCTORS + globalConstants.SUCCESS:
      return {
        ...state,
        allCenterInstructors: action.data,
      };
    default:
      return state;
  }
};

export default InstructorReducer;
